<p-button
  [type]="type"
  [disabled]="disabled || loading"
  [label]="label | translate"
  [icon]="icon"
  [iconPos]="iconPos"
  [styleClass]="btnClass + ' ' + size"
  [style]="cssVars"
  [loading]="loading"

  [pTooltip]="tooltip"
  [tooltipPosition]="tooltipPosition"

  (click)="onClick($event)"
  (focus)="focus.emit($event)"
  (blur)="blur.emit($event)"
>
  <ng-content></ng-content>
</p-button>
